import React from 'react';
import PropTypes from  'prop-types';
import { inject, observer } from "mobx-react";
import  { withStyles } from  '@material-ui/core/styles';
import LinearProgress from '@material-ui/core/LinearProgress';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Grid from '@material-ui/core/Grid';
import ListSubheader from '@material-ui/core/ListSubheader';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import Collapse from '@material-ui/core/Collapse';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Button from '@material-ui/core/Button';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import InputAdornment from '@material-ui/core/InputAdornment';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import Typography from '@material-ui/core/Typography';
import Checkbox from '@material-ui/core/Checkbox';
import debounce from 'lodash/debounce';
import Stripe from '../Stripe'

const styles = theme => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
    minWidth: 400,
    minHeight: 300,
  },
  stripRoot: {
    width: '100%',
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: theme.typography.fontWeightRegular,
  },
  button: {
    marginTop: theme.spacing.unit * 2,
  },
  newPaymentPanel: {
    marginTop: theme.spacing.unit * 2,
  },
  agreement:{
    textAlign: 'left',
    color: theme.palette.text.secondary,
  },
});


@inject("authStore", "commonStore")
@observer
class AddCredit extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      amount:0,
      panelOpen: false,
      agreed: false
    }
  }
  async componentDidMount() {
   this.props.authStore.syncUser()
  }
  handleUpdate = (field, value, valid) => {

    this.setState({[field]: value})
  }
  handleChange = (amount) => {
    if(amount === '' || amount === undefined || amount === null){
      this.setState({amount: 0})
    }
    if(parseInt(amount)){
      this.setState({amount: amount * 100})
    }
  }

  handlePurchase = debounce(() => {
  //handlePurchase = () => {
    const { addToAvailibleCredit } = this.props.authStore 
    const { amount, selectedCard, agreed } = this.state
    if(!agreed){
      return
    }
    selectedCard.amount = amount
    addToAvailibleCredit(selectedCard)
    //this.props.handleClose(updated)
  }, 1000)


  handleCancel = () => {
    this.props.handleClose()
  };
  handleClearMessage = () => {
    console.log('handleClearMessage')
    const { setPaymentProgress, paymentProgress } = this.props.commonStore
    const { type } = paymentProgress
    setPaymentProgress({isProcessing: false})
    if(type === 'addCredit'){
      this.props.handleClose()
    }else{
      this.setState({panelOpen: false})
    }
 
  }
  handleOpenPanel = () => {
    const { panelOpen } = this.state
    this.setState({panelOpen: !panelOpen})
  }
  makePaymentAddResultActions = () => {
    const { classes, commonStore } = this.props
    const { paymentProgress } = commonStore
    const { isProcessing, result, message } = paymentProgress

    console.log(isProcessing)

    if (!isProcessing && result === 'success'){
      return (<div><Typography variant="body1">{message} </Typography> <Button className={classes.button} variant="contained" color="primary" onClick={this.handleClearMessage}> OK </Button> </div>)
    }else if (!isProcessing && result === 'error'){
      return (<div><Typography color="error" variant="body1">{message} </Typography> <Button className={classes.button} variant="contained" color="primary" onClick={this.handleClearMessage}> OK </Button></div> )
    }
  }
  makeActions = () => {
    const { classes, commonStore } = this.props
    const { paymentProgress } = commonStore
    const { isProcessing, result, message, type } = paymentProgress
    const { amount, selectedCard, agreed } = this.state 
    const { agent } = this.props.commonStore

    if (!isProcessing && result === 'success' && type === 'addCredit'){
      return (<div style={{width: '100%'}}><Typography variant="body1">{message} </Typography> <Button className={classes.button} variant="contained" color="primary" onClick={this.handleClearMessage}> OK </Button></div>)
    }else if (!isProcessing && result === 'error' && type === 'addCredit'){
      return (<div style={{width: '100%'}}><Typography variant="body1">{message} </Typography> <Button className={classes.button} variant="contained" color="primary" onClick={this.handleClearMessage}> OK </Button> </div>)
    }else if(!isProcessing) {
     return( 
       <div style={{width: '100%'}}>{ amount > 0 && selectedCard && agreed ? <Button onClick={() => {this.handlePurchase()}} color="primary"> Purchase </Button> : null}
      <Button onClick={this.handleCancel} color="primary">Cancel</Button> </div>
      )
    }else{
      console.log('show linear')
      return <LinearProgress style={{margin:20}} color="secondary" /> 
    }
  }
  makeListItems = () => {

    const { classes, commonStore } = this.props
    const { cards } = commonStore
    
    const items = cards 
    let count = 0

    if (items.length == 0){
      return (<Typography variant="body1"> No saved cards. Please add a default card.</Typography>)
    }
    
    const itemsArray = items.map(item => {
      count = count + 1;
      const indexName = `open${count}`;
          return (<div key={count}>
            <ListItem button onClick={() => {this.setState({selectedCard: item})}}>
            <Checkbox
            //checked={this.state.checked.indexOf(value) !== -1}
            color='primary'
            tabIndex={-1}
            disableRipple
            />
            <ListItemText primary={`${item.brand}`} />
            <ListItemText primary={`${item.last4}`} />
            <ListItemText primary={`${item.exp_month}/${item.exp_year}`} />
              {this.state[indexName] ? <ExpandMore /> : <ExpandLess />}
            </ListItem>
           {/*} <Collapse in={this.state[indexName]} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                <ListItem className={classes.nested}>
                <ListItemText  primary={`Distributor:`} secondary={item.product.distributor}/>   
                <ListItemText  primary={`ASIN:`} secondary={item.product.asin}/>
                <ListItemText  primary={`Product Id:`} secondary={item.product.product}/>
                </ListItem>
              </List>
          </Collapse>*/}</div>)
          })

    return itemsArray
  }
  makeAgreement = () => {
    const { agreed } = this.state 
    const { classes } = this.props
    return <Grid item xs={12}>
    <Grid
      container
      className={classes.agreement}
      alignItems={'center'}
      direction={'row'}
      justify={'flex-start'}
    >
   
    <Grid item >
        <Checkbox
        color='primary'
        checked={agreed}
        onChange={() => {this.handleUpdate('agreed', !agreed, true)}}
      />
          {'I have read and agree to the '}
     
    </Grid>
    <Grid item >
    <Button href="https://www.sonicwebdev.com/terms-and-conditions" target="_blank" >terms and conditions</Button>
    </Grid>
    </Grid>
  </Grid>
  }
  render() {
    
    const { amount, selectedCard, panelOpen, agreed } = this.state 
    const { classes, open, commonStore } = this.props
    const { paymentProgress } = commonStore
    const { isProcessing, result, message, type } = paymentProgress
    const { agent, network, cards } = commonStore


    console.log(agent.credit)

    return (

        <Dialog
          open={open}
          onClose={this.handleClose}
          aria-labelledby="form-dialog-title"
        >
        <div className={classes.root} style={{width:'600px', height:'500px'}}>
        <DialogTitle id="form-dialog-title">Add Credit  
        <Typography variant="caption" gutterBottom >{`Current avail. credit: $${(agent.credit / 100).toLocaleString()}`}</Typography> 
        </DialogTitle>
     
        <DialogContent>
        <FormControl fullWidth className={classes.margin}>
       
  
        <InputLabel htmlFor="adornment-amount">Amount</InputLabel>
        <Input
          disabled={cards.length === 0}
          id="adornment-amount"
          value={amount / 100}
          onChange={(event) => {this.handleChange(event.target.value)}}
          startAdornment={<InputAdornment position="start">$</InputAdornment>}
        /> 
      </FormControl>
        <Typography variant="caption" gutterBottom >{`Your network is matching $${network.dollarMatch} on the dollar, Your avail. credit will be: $${((agent.credit + (amount * network.dollarMatch) + amount) / 100).toLocaleString()}`}</Typography>
          
     
        <ExpansionPanel className={classes.newPaymentPanel} expanded={panelOpen} onChange={this.handleOpenPanel}>
          <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
            <Typography className={classes.heading}>Add New Payment Method</Typography>
          </ExpansionPanelSummary>
          <ExpansionPanelDetails >
          
         {result && type === 'addMethod' ? this.makePaymentAddResultActions() :  <div className={classes.stripRoot}>
          <Stripe/>
          </div>}

          </ExpansionPanelDetails>
        </ExpansionPanel>
        <List>
         {panelOpen ? null : this.makeListItems()}
        </List>
        {isProcessing ?  <LinearProgress style={{margin:20}} color="secondary" /> : null}
   
        {this.makeAgreement()}
       
        </DialogContent>
        <DialogActions>

        {this.makeActions()}

      </DialogActions>
        </div>

        </Dialog>

    );
  }
}

AddCredit.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(AddCredit);



// WEBPACK FOOTER //
// ./src/components/Leads/AddCreditDialog.js